import { PAGE } from "constants/configConstants";
import { DEFAULT_HEADER_RENDER_VARIANT, HeaderRenderVariant } from "./headerRenderVariant";

export type SiteHeaderGateProps = {
  headerVariant?: HeaderRenderVariant;
  isWhitelabel?: boolean;
  transparentBg?: boolean;
  rightContent?: unknown;
  parentPage?: string;
  isProfileHeader?: boolean;
  isSubProfileHeader?: boolean;
  showBackButton?: boolean;
  isBlogHeader?: boolean;
  isNewsHeader?: boolean;
  isExamsHeader?: boolean;
  isAmberPlusHeader?: boolean;
  isAmberPlusCategoryHeader?: boolean;
  isMediaHeader?: boolean;
  isPodcastHeader?: boolean;
  isAmbassadorHeader?: boolean;
  isScholarshipPage?: boolean;
  isMediaMentionsHeader?: boolean;
  isCareerPage?: boolean;
};

/** Pages that keep the legacy header (PDP mobile uses PropertyHeader, not this gate). */
export const shouldUseSiteHeader = ({
  headerVariant = DEFAULT_HEADER_RENDER_VARIANT,
  isWhitelabel = false,
  transparentBg = false,
  rightContent = null,
  parentPage = "",
  isProfileHeader = false,
  isSubProfileHeader = false,
  showBackButton = false,
  isBlogHeader = false,
  isNewsHeader = false,
  isExamsHeader = false,
  isAmberPlusHeader = false,
  isAmberPlusCategoryHeader = false,
  isMediaHeader = false,
  isPodcastHeader = false,
  isAmbassadorHeader = false,
  isScholarshipPage = false,
  isMediaMentionsHeader = false,
  isCareerPage = false,
}: SiteHeaderGateProps): boolean => {
  if (headerVariant !== "site" || isWhitelabel) return false;
  if (transparentBg || rightContent) return false;
  if (parentPage === PAGE.HOME) return false;
  if (
    isProfileHeader ||
    isSubProfileHeader ||
    showBackButton ||
    isBlogHeader ||
    isNewsHeader ||
    isExamsHeader ||
    isAmberPlusHeader ||
    isAmberPlusCategoryHeader ||
    isMediaHeader ||
    isPodcastHeader ||
    isAmbassadorHeader ||
    isScholarshipPage ||
    isMediaMentionsHeader ||
    isCareerPage
  ) {
    return false;
  }
  return true;
};
